import React from 'react';
import { DataSelection } from '@/pages/DataSelection';
import WizardStepHeading from './WizardStepHeading';

/**
 * Wizard Step 4 — "Data Editor" (Figma 3001-68426).
 * Hosts the existing Data Editor (overview cards, filters, search, export,
 * edit columns) for the created usecase. Unlike the task page, the wizard
 * shows the same Train / Benchmark / Archived tabs horizontally (no left
 * rail) so the table spans nearly the full card width.
 */
const DataEditorStep = ({ activeUsecaseId, taskName, moveToScreen, onBack, onNext }) => {
    if (!activeUsecaseId) return null;

    return (
        <div className="cw-step cw-step--hosted">
            <WizardStepHeading
                title="Data Editor"
                taskName={taskName}
                onBack={onBack}
                onNext={onNext}
            />
            <DataSelection
                key={activeUsecaseId}
                embeddedInTaskDrawer
                topTabs
                moveToScreen={moveToScreen}
            />
        </div>
    );
};

export default DataEditorStep;
